'use client';
import { message, TreeSelect } from 'antd';
import { API } from 'data';
import { RestAPI } from 'scripts';
import { CategoryType, CategoryVolumeEnum, PaginationType } from 'types';
import { useEffect, useState } from 'react';

function CategorySelectComp(props: {
    onChange?: (e: number | string) => void;
    className?: string;
    placeholder?: string;
    onPriceChange: (e: number) => void;
    id?: string;
}) {
    const [categories, setCategories] = useState<CategoryType<'list'>[]>();
    const getPropertiesOfCategory = (categoryID: string) => {
        const id = categoryID.replace('bulk-', '');
        props.onChange?.(id);
        const cat = categories?.find((i) => i.id.toString() === id);
        if (cat) props.onPriceChange(cat.price);
    };

    useEffect(() => {
        RestAPI.get<PaginationType<CategoryType<'list'>>>(API.category.list, {
            page_size: 450,
            ordering: '-order',
        })
            .then((res) => setCategories(res.data.data))
            .catch(() => message.error('خطایی رخ داده است. لطفا بعدا تلاش نمایید'));
    }, []);

    let treeData = (categories ?? [])
        .filter((i) => i.volume !== CategoryVolumeEnum.multi)
        .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
        .map((item) => ({
            id: item.id.toString(),
            pId: item.parent?.toString(),
            value: item.id.toString(),
            isLeaf: !(categories ?? []).find((i) => i.parent === item.id),
            title: item.title,
            selectable: !(categories ?? []).find((i) => i.parent === item.id),
        }));
    treeData = [
        // { id: '0', value: '0', title: 'عمده فروشی', isLeaf: false, pId: undefined, selectable: false },
        ...(categories
            ? categories
                  .filter((i) => i.volume !== CategoryVolumeEnum.single)
                  .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                  .map((i) => {
                      const parent = categories.find((item) => item.id === i.parent);
                      return {
                          id: 'bulk-' + i.id,
                          pId: parent && parent.volume !== CategoryVolumeEnum.single ? 'bulk-' + i.parent : '0',
                          value: 'bulk-' + i.id.toString(),
                          isLeaf: !(categories ?? []).find((item) => item.parent === i.id),
                          title: i.title,
                          selectable: !(categories ?? []).find((item) => item.parent === i.id),
                      };
                  })
            : []),
        ...treeData,
    ];

    return (
        <TreeSelect
            id={props.id}
            className={props.className}
            treeDataSimpleMode
            onSelect={getPropertiesOfCategory}
            placeholder={props.placeholder}
            treeData={treeData}
            treeExpandAction="click"
        />
    );
}

export default CategorySelectComp;
